import React from 'react';
import Arrow from '../../../../../assets/images/applicants/landing_page/down-arrow-cashew.svg'

type NavLink = {
  text: string;
  url?: string;
};

export type BreadcrumbsProps = {
  navLinks: NavLink[];
};

export const Breadcrumbs = ({ navLinks }: BreadcrumbsProps) => (
  <nav className="lg:max-w-7xl m-auto pt-6 text-cashew text-sm" aria-label="breadcrumbs">
    <ul className="flex">
      {navLinks.map((link, index) => {
        if (index === navLinks.length - 1) {
          return (
            <li key={index} className="font-medium">
              <span aria-current="page">{link.text}</span>
            </li>
          );
        }
        return (
          <li key={index} className="font-light">
            <a href={link.url}>{link.text}</a>
            <img src={Arrow} alt="arrow" className="transform -rotate-90 inline mx-2 lg:mx-4 w-3 lg:w-3.5" />
          </li>
        );
      })}
    </ul>
  </nav>
);
